/**
 * Plugin wrapper for C3 to expose as a Vue global, $tinymce.
 * This lets us mock it during testing.
 */

import c3 from 'c3'

const C3 = {
  // The install method is all that needs to exist on the plugin object.
  // It takes the global Vue object as well as user-defined options.
  install (Vue, options) {
    Vue.prototype.$c3 = c3
  }
}

export default C3
